import api from './api';

// Fonction pour diffuser un message via Telegram
export const broadcastMessage = async (userType, message) => {
  try {
    const response = await api.post('/telegram/broadcast', {
      user_type: userType,
      message: message
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la diffusion du message:", error);
    throw error;
  }
};

// Fonction pour demander un code de liaison Telegram
export const requestTelegramLink = async (phone) => {
  try {
    const response = await api.post('/telegram/request-link', {
      phone: phone
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la demande de liaison Telegram:", error);
    throw error;
  }
};

// Nouvelle fonction : Vérifier le statut de liaison Telegram
export const getTelegramStatus = async () => {
  try {
    const response = await api.get('/telegram/status');
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la vérification du statut Telegram:", error);
    throw error;
  }
};

// Nouvelle fonction : Délier le compte Telegram
export const unlinkTelegram = async () => {
  try {
    const response = await api.delete('/telegram/unlink');
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la déliaison Telegram:", error);
    throw error;
  }
};